import { uuidRegExpString } from '~/utils/Url';

const DURABLE_MONIKER_WIRE_UUID_REGEXP = new RegExp(`^${uuidRegExpString}$`, 'i');

/**
 * Wire ids embedded in `@[entity:…]` must be strict UUIDs with no whitespace or `]` — otherwise pasted
 * pill HTML can close the moniker early and smuggle prose into skill instructions.
 */
export const isDurableMonikerWireUuid = (value: string): boolean => {
  if (value.length === 0 || /[\s\]]/.test(value)) {
    return false;
  }

  return DURABLE_MONIKER_WIRE_UUID_REGEXP.test(value);
};
